import { Fab } from "@mui/material";
import { motion } from "framer-motion"; // For animations if needed
import React, { forwardRef } from "react";

interface FloatingButtonContainerProps {
  side?: "right" | "left";
}

const FloatingButtonContainer: React.FC<
  React.PropsWithChildren<FloatingButtonContainerProps>
> & {
  Button: React.ForwardRefExoticComponent<
    FloatingButtonProps & React.RefAttributes<HTMLButtonElement>
  >;
} = ({ children, side = "right" }) => {
  return (
    <div
      className={`flex flex-col gap-4 fixed bottom-8 ${
        side === "left" ? "left-8" : "right-8"
      } z-50`}>
      {children}
    </div>
  );
};

interface FloatingButtonProps {
  onClick?: () => void;
  icon: React.JSX.Element;
  bgColor?: string;
}

const FloatingButton = forwardRef<HTMLButtonElement, FloatingButtonProps>(
  ({ onClick, icon, bgColor = "#C64192", ...props }, ref) => {
    return (
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5 }}>
        <Fab
          title="asdas"
          ref={ref}
          style={{
            backgroundColor: bgColor,
            color: "white",
            width: 50,
            height: 50,
          }}
          aria-label="add"
          onClick={onClick}
          className="hover:scale-110"
          {...props}>
          {icon}
        </Fab>
      </motion.div>
    );
  }
);

FloatingButtonContainer.Button = FloatingButton;

export default FloatingButtonContainer;
